module.exports = __webpack_public_path__ + "img/empty-page-list.9c84a5bb.svg";